import React, { Component } from "react";
import foto1 from "../asset/foto 1.png";
import AOS from "aos";
import "aos/dist/aos.css";
import { HiDownload } from 'react-icons/hi';
class About extends Component {
  componentDidMount() {
    AOS.init();
  }

  render() {
    return (
      <div id="about" className="">
        <h2 className="text-center font-extrabold text-4xl  mt-4 max-md:text-xl font-EBGaramond"> About Us</h2>
        {/* <span className=" bg-primer inline-flex justify-center items-center  w-[14%] ml-[43%] h-2"></span> */}
        <br />

        <div className="max-w-[1400px] m-auto py- px-4 grid lg:grid-cols-2 gap-4  ">
          {/* left Side */}
          <div
            className="flex flex-col h-full justify-center"
            data-aos="fade-down"
            data-aos-duration="1000"
          >
            <div className="text-left max-md:text-sm font-Montserrat">
              <h2 className=" font-bold text-dark text-5xl max-md:text-2xl  ">
                The Leading Supplier of
                <br />
                <span className="text-primer font-Montserrat"> Vanilla Beans</span>
              </h2>
            </div>

            <p className="text-dark mb-4  text-2xl md:text-lg max-md:text-sm mt-4 font-Montserrat ">
              Our company is a leading supplier of vanilla bean products from
              Indonesia, one of the largest spice producing countries in the
              world. We have become the main player in the global trade in
              vanilla beans that is reliable and trustworthy. With our
              expertise, we are able to meet the demand for large quantities of
              vanilla beans on an ongoing basis with the best quality for export
              purposes{" "}
              <span className="text">
                so that we can become the first choice as a supplier of seafood
                from Indonesia.
              </span>
              
            </p>
            <div className="bg-center max-sm:pt-2 max-sm:mb-2 font-EBGaramond hover:scale-105">
              <a
                href="https://drive.google.com/file/d/1EXO5ETasSEOyjkYg6Y_wGAwLl0SxaTnv/view?usp=sharing"
                class="bg-primer w-[45%] max-sm:w-[60%] text-xl text-white  font-bold py-2 px-4  rounded max-sm:text-sm  flex items-center"
              >
               
                Download Catalog
                <HiDownload className="ml-2" />
              </a>
              {" "}
            </div>
          </div>

          {/* right Side */}
          <div
            className="grid   w-[full]"
            data-aos="fade-down"
            data-aos-duration="2000"
          >
            <img src={foto1} alt="Export Import Activity" />
          </div>
        </div>
      </div>
    );
  }
}

export default About;
